import { render } from "./ClientLocation.vue?vue&type=template&id=071b4433"
import script from "./ClientLocation.vue?vue&type=script&lang=js"
export * from "./ClientLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__